<app-admin-header></app-admin-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
